<div class="pageheader">
    <div class="page-title">
        <h1>Identification types</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Developer_Action_IdentificationTypesShowLog'" [title]="'Identification types log'">
                <app-change-log-link-entity type="IdentificationType"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<div class="">
    <div class="row">
        <div class="col-sm-12">

            <dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='idTypes' [bizSetColumnChooser]="true"
                [bizSetAllowColumnReordering]="false" [bizSetGroupPanel]="false" (onInitNewRow)="onInitNewRow($event)"
                (onRowInserting)="onRowInserting($event)" (onRowUpdating)="onRowUpdating($event)"
                (onRowRemoving)="onRowRemoving($event)" [masterDetail]="{ enabled: true, template: 'qualifiers' }"
                [bizEditRowOnDoubleClick]="true">

                <dxo-editing mode="popup" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding"
                    [allowDeleting]="allowDeleting">
                    <dxo-popup title="Identification type" [showTitle]="true"></dxo-popup>
                </dxo-editing>

                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

                <dxi-column dataField="Name" caption="Name" dataType="string" sortOrder="asc">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-column>

                <dxi-column dataField="Description" caption="Description" dataType="string">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-column>

                <dxi-column dataField="DefaultQualifierEdifact" caption="Default Edifact Qualifier" dataType="string">
                </dxi-column>

                <dxi-column dataField="DefaultQualifierX12" caption="Default X12 Qualifier" dataType="string">
                </dxi-column>

                <dxi-column dataField="RegularExpression" caption="Reg.Ex." dataType="string">
                </dxi-column>

                <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.idTypes, 'CreatedBy'))"></dxo-header-filter></dxi-column>
                <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
                <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.idTypes, 'UpdatedBy'))"></dxo-header-filter>   </dxi-column>
                <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

                <dxi-column type="buttons">
                    <dxi-button name="edit"></dxi-button>
                    <dxi-button name="delete"></dxi-button>
                    <dxi-button text="Show Log"
                                template="logTemplate"
                                [visible]="allowShowLog">
                    </dxi-button>
                </dxi-column>

                <ng-container *dxTemplate="let cell of 'logTemplate'">
                    <app-change-log-link *bizPermissionRequired="'Developer_Action_IdentificationTypesShowLog'" [title]="'Logs for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
                        <app-change-log-link-entity type="IdentificationType" [id]="cell.data.IdentificationTypeId"></app-change-log-link-entity>
                    </app-change-log-link>
                </ng-container>

                <ng-container *dxTemplate="let cellInfo of 'qualifiers'">
                    <div style="border: 1px solid #ddd; border-radius: 5px; padding: 1em; background-color: white;">
                        <label>Identification type qualifiers</label>
                        <dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='cellInfo.data.Qualifiers'
                            [bizSetColumnChooser]="false" [bizSetAllowColumnReordering]="false"
                            [bizHideSelectedRowsComponent]="true" [showResetButton]="false" [bizSetGroupPanel]="false"
                            [bizSetPager]="false" [bizSetSearchPanel]="false"
                            (onInitNewRow)="onQualifierInitNewRow($event, cellInfo.data)"
                            (onRowInserted)="onQualifierRowInsertedOrUpdated($event)"
                            (onRowUpdated)="onQualifierRowInsertedOrUpdated($event)"
                            (onRowRemoved)="onQualifierRowRemoved($event)">

                            <dxo-editing mode="row" [allowUpdating]="allowUpdatingQualifier"
                                [allowAdding]="allowAddingQualifier" [allowDeleting]="allowDeletingQualifier">
                            </dxo-editing>

                            <dxi-column dataField="Qualifier" caption="Qualifier" dataType="string" sortOrder="asc"
                                [allowGrouping]="false" [allowFiltering]="false" [allowSorting]="false">
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                            </dxi-column>
                        </dx-data-grid>
                    </div>
                </ng-container>
            </dx-data-grid>

        </div>
    </div>
</div>
